var React = require('react');

function UnternehmenOnlineArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M415.471 5.99294C416.84 4.62827 416.843 2.41219 415.479 1.0432C414.114 -0.32579 411.898 -0.329292 410.529 1.03538L415.471 5.99294ZM0 3.51416L14.4904 41.2416L39.9181 9.8289L0 3.51416ZM410.529 1.03538C368.609 42.8233 297.367 64.2113 223.785 66.7562C150.248 69.2996 75.3208 52.9841 26.4169 20.4144L22.5367 26.2406C73.0369 59.8734 149.559 76.3276 224.027 73.752C298.451 71.178 371.768 49.558 415.471 5.99294L410.529 1.03538Z","fill":"#4D6888"}));
}

UnternehmenOnlineArrowLeft.defaultProps = {"width":"417","height":"75","viewBox":"0 0 417 75","fill":"none"};

module.exports = UnternehmenOnlineArrowLeft;

UnternehmenOnlineArrowLeft.default = UnternehmenOnlineArrowLeft;
